export enum SubscriptionPlan {
    ALL = 'All',
    MONTHLY = 'Monthly',
    ANNUALLY = 'Annually',
}